import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContext, useReducer, useRef, useCallback, useEffect, useMemo } from 'react';
import { UPDATE_FIELD, TERMINATE_FIELD, VALIDATE_FIELD, FormStableContext } from '../react-forms';
import { useFieldArrayContext } from '../field-array';
import { uuid } from '../utils';
import { get, noop, isFunction } from 'lodash';
var SET_FOCUSED = 'SET_FOCUSED';
var SET_VALUE = 'SET_VALUE';
var SET_TOUCHED = 'SET_TOUCHED';
var SET_ERROR = 'SET_ERROR';
var SET_IS_VALIDATING = 'SET_IS_VALIDATING';
var RESET = 'RESET';
var VALIDATE = 'VALIDATE';
var immediateUpdateType = ['checkbox', 'radio'];

var reducer = function reducer(state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;
  var prevInitialValue = state.initialValue,
      prevValue = state.value,
      prevFocused = state.focused,
      prevTouched = state.touched,
      prevError = state.error;

  switch (type) {
    case SET_FOCUSED:
      {
        var _ref2;

        var focused = payload.focused;
        return _objectSpread(_objectSpread({}, state), {}, {
          focused: (_ref2 = isFunction(focused) ? focused(prevFocused) : focused) !== null && _ref2 !== void 0 ? _ref2 : false
        });
      }

    case SET_VALUE:
      {
        var _ref3;

        var value = payload.value;
        return _objectSpread(_objectSpread({}, state), {}, {
          value: (_ref3 = isFunction(value) ? value(prevValue) : value) !== null && _ref3 !== void 0 ? _ref3 : ''
        });
      }

    case SET_TOUCHED:
      {
        var _ref4;

        var touched = payload.touched;
        return _objectSpread(_objectSpread({}, state), {}, {
          touched: (_ref4 = isFunction(touched) ? touched(prevTouched) : touched) !== null && _ref4 !== void 0 ? _ref4 : false
        });
      }

    case SET_ERROR:
      {
        var _ref5;

        var error = payload.error,
            shouldTouch = payload.shouldTouch;
        return _objectSpread(_objectSpread({}, state), {}, {
          touched: shouldTouch || prevTouched,
          error: (_ref5 = isFunction(error) ? error(prevError) : error) !== null && _ref5 !== void 0 ? _ref5 : null
        });
      }

    case SET_IS_VALIDATING:
      {
        var isValidating = payload.isValidating;
        return _objectSpread(_objectSpread({}, state), {}, {
          isValidating: isValidating
        });
      }

    case RESET:
      {
        var _value = payload.value;
        var newValue = isFunction(_value) ? _value(prevValue) : _value !== undefined ? _value : prevInitialValue;
        return _objectSpread(_objectSpread({}, state), {}, {
          initialValue: newValue,
          value: newValue,
          focused: false,
          touched: false,
          error: null
        });
      }

    case VALIDATE:
      {
        var id = payload.id,
            field = payload.field,
            _value2 = payload.value,
            formDispatch = payload.formDispatch; // HACK: We want to be validating the current
        // value of the field even if we run onChange
        // and onBlur synchronously
        // TODO: Find a way to do this without dispatching
        // from within the reducer

        formDispatch({
          id: id,
          type: VALIDATE_FIELD,
          payload: {
            field: field,
            value: _value2 !== undefined ? _value2 : prevValue
          }
        });
        return state;
      }

    default:
      return state;
  }
};

function useField(name) {
  var _ref7;

  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      propId = _ref6.id,
      propInitialValue = _ref6.initialValue,
      _ref6$sendImmediate = _ref6.sendImmediate,
      sendImmediate = _ref6$sendImmediate === void 0 ? false : _ref6$sendImmediate,
      _ref6$onFocus = _ref6.onFocus,
      onFocus = _ref6$onFocus === void 0 ? noop : _ref6$onFocus,
      _ref6$onChange = _ref6.onChange,
      onChange = _ref6$onChange === void 0 ? noop : _ref6$onChange,
      _ref6$onBlur = _ref6.onBlur,
      onBlur = _ref6$onBlur === void 0 ? noop : _ref6$onBlur,
      propValidate = _ref6.validate;

  var _useContext = useContext(FormStableContext),
      safeMode = _useContext.safeMode,
      formPropInitialValues = _useContext.initialValues,
      touchOnChange = _useContext.touchOnChange,
      touchOnBlur = _useContext.touchOnBlur,
      validateOnChange = _useContext.validateOnChange,
      validateOnBlur = _useContext.validateOnBlur,
      formDispatch = _useContext.dispatch;

  var fieldArrayId = useFieldArrayContext();
  var actualInitialValue = (_ref7 = propInitialValue !== undefined ? propInitialValue : get(formPropInitialValues, name)) !== null && _ref7 !== void 0 ? _ref7 : '';

  var _useReducer = useReducer(reducer, {
    initialValue: actualInitialValue,
    focused: false,
    value: actualInitialValue,
    touched: false,
    error: null,
    isValidating: false
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var initialValue = state.initialValue,
      focused = state.focused,
      value = state.value,
      touched = state.touched,
      error = state.error,
      isValidating = state.isValidating;
  var id = useRef(propId !== null && propId !== void 0 ? propId : uuid());
  var fieldType = useRef(null); // Some fields we always want to update on every change

  var typeUpdate = _includesInstanceProperty(immediateUpdateType).call(immediateUpdateType, fieldType.current); // Either update the form all the time
  // if the user wants or whenever the field is
  // not focused - this covers every case for when
  // we want to send state to the form


  var updateImmediate = useMemo(function () {
    return typeUpdate || sendImmediate || !focused;
  }, [focused, sendImmediate, typeUpdate]);
  var setTouched = useCallback(function (touched) {
    dispatch({
      type: SET_TOUCHED,
      payload: {
        touched: touched
      }
    });
  }, []);
  var setError = useCallback(function (error, shouldTouch) {
    dispatch({
      type: SET_ERROR,
      payload: {
        error: error,
        shouldTouch: shouldTouch
      }
    });
  }, []);
  var setIsValidating = useCallback(function (isValidating) {
    dispatch({
      type: SET_IS_VALIDATING,
      payload: {
        isValidating: isValidating
      }
    });
  }, []);
  var reset = useCallback(function (value) {
    dispatch({
      type: RESET,
      payload: {
        value: value
      }
    });
  }, []);
  var validate = useCallback(function (value) {
    dispatch({
      type: VALIDATE,
      payload: {
        id: id.current,
        value: value,
        formDispatch: formDispatch,
        // HACK: This is a quick-fix to stop
        // inputs that call onBlur or onChange
        // synchronously from erroring because
        // there isn't a field entry yet
        field: {
          name: name,
          setTouched: setTouched,
          setError: setError,
          setIsValidating: setIsValidating,
          propValidate: propValidate
        }
      }
    });
  }, [formDispatch, name, propValidate, setError, setIsValidating, setTouched]);
  var setValue = useCallback(function (value, shouldValidate) {
    dispatch({
      type: SET_VALUE,
      payload: {
        value: value
      }
    });

    if (shouldValidate) {
      validate();
    }
  }, [validate]);
  var field = useMemo(function () {
    return {
      name: name,
      fieldArrayId: fieldArrayId,
      propValidate: propValidate,
      setValue: setValue,
      setTouched: setTouched,
      setError: setError,
      setIsValidating: setIsValidating,
      reset: reset,
      validate: validate
    };
  },
  /* eslint-disable react-hooks/exhaustive-deps */
  [name, setValue, setTouched, setError, setIsValidating, reset, validate, !safeMode && propValidate]
  /* eslint-enable react-hooks/exhaustive-deps */
  );
  var handleFocus = useCallback(function (e) {
    dispatch({
      type: SET_FOCUSED,
      payload: {
        focused: true
      }
    });
    onFocus(e);
  }, [onFocus]);
  var handleChange = useCallback(function (e) {
    var type = e.target.type;
    var value = type === 'checkbox' ? e.target.checked : type === 'file' ? e.target.files : e.target.value;
    fieldType.current = type;
    setValue(value);
    setTouched(function (touched) {
      return touched || touchOnChange;
    });

    if (validateOnChange) {
      validate();
    }

    onChange(e);
  }, [setValue, touchOnChange, validateOnChange, onChange, setTouched, validate]);
  var handleBlur = useCallback(function (e) {
    dispatch({
      type: SET_FOCUSED,
      payload: {
        focused: false
      }
    });
    setTouched(function (touched) {
      return touched || !!touchOnBlur;
    });

    if (validateOnBlur) {
      validate();
    }

    onBlur(e);
  }, [setTouched, validateOnBlur, onBlur, touchOnBlur, validate]);
  useEffect(function () {
    var fieldId = id.current;
    return function () {
      formDispatch({
        id: fieldId,
        type: TERMINATE_FIELD
      });
      fieldType.current = null;
    };
  }, [name]); // eslint-disable-line

  useEffect(function () {
    if (updateImmediate) {
      formDispatch({
        id: id.current,
        type: UPDATE_FIELD,
        payload: {
          field: field,
          initialValue: initialValue,
          value: value,
          touched: touched,
          error: error
        }
      });
    }
  }, [field, initialValue, value, touched, error, formDispatch, updateImmediate]);
  var input = useMemo(function () {
    return {
      value: value,
      id: id.current,
      name: id.current,
      onFocus: handleFocus,
      onChange: handleChange,
      onBlur: handleBlur
    };
  }, [value, handleFocus, handleChange, handleBlur]);
  var meta = useMemo(function () {
    return {
      error: error,
      touched: touched,
      focused: focused,
      initialValue: initialValue,
      isValidating: isValidating
    };
  }, [error, touched, focused, initialValue, isValidating]);
  var actions = useMemo(function () {
    return {
      setValue: setValue,
      setTouched: setTouched,
      setError: setError,
      setIsValidating: setIsValidating,
      reset: reset,
      validate: validate
    };
  }, [setValue, setTouched, setError, setIsValidating, reset, validate]);
  return [input, meta, actions];
}

export { useField };